/**
 * Check whether a `HYBRID_SEARCH_ENABLED` feature value turns hybrid search on.
 * Accepts `true`, `'true'`, and `''` (flag present without a value).
 * @param {boolean|string} value - Raw feature flag value.
 * @returns {boolean} Whether hybrid search is enabled.
 */
export const isHybridSearchFlagEnabled = (value) =>
  value === true || value === 'true' || value === '';

export default isHybridSearchFlagEnabled;
